import React from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import SidebarBrand from './sidebar-brand.jsx';
import SidebarNav from './sidebar-nav.jsx';

class Sidebar extends React.Component {
	static contextType = AppSettings;
	
	render() {
		return (
			<AppSettings.Consumer>
				{({toggleAppSidebarMobile, appSidebarTransparent, appSidebarGrid}) => (
					<React.Fragment>
						<div id="sidebar" className={'app-sidebar ' + (appSidebarTransparent ? 'app-sidebar-transparent' : '') + (appSidebarGrid ? 'app-sidebar-grid' : '')}>
							<div className="app-sidebar-content">
								<SidebarBrand />
								<div className="donezo-sidebar-nav">
									<SidebarNav />
								</div>
							</div>
						</div>
						<div className="app-sidebar-bg"></div>
						<div className="app-sidebar-mobile-backdrop"><Link to="/" onClick={toggleAppSidebarMobile} className="stretched-link"></Link></div>
					</React.Fragment>
				)}
			</AppSettings.Consumer>
		)
	}
}

export default Sidebar;
